import { Injectable } from '@angular/core';
import { AsyncValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { ColDef, ColGroupDef } from 'ag-grid-community';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Observable, map, catchError, of } from 'rxjs';
import { IAPIResponse } from '../../shared/models';
import { MasterPopupComponent } from '../components/master-popup/master-popup.component';
import { UserDetailsComponent } from '../components/user-details/user-details.component';
import { AdminDashboardEnum, AdminMasterEnum, IAdminMasterTab } from '../models';
import { IItracerRequest, IITracerUser, IUser } from '../models/admin.model';
import { AdminService } from './admin.service';
import { MappingPopupComponent } from '../components/mapping-popup/mapping-popup.component';
import { SupplierPopupComponent } from '../components/supplier-popup/supplier-popup.component';

export function existingItracerUserValidator(_adminService: AdminService): AsyncValidatorFn {
  return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
    const itracerReq : IItracerRequest = { "username": control.value, "role":"SiemensUser", "domain":"AD001" };
    return _adminService.getItacerUser(itracerReq).pipe(
      map(
        ({ data : iTracerUsers }: IAPIResponse<IITracerUser[]>) => {
          return (iTracerUsers && iTracerUsers.length > 0) ? null : of({ "userNotExists": true });
        }
      ),
      catchError( (err : any, caught : any) => {
        return of({ "userNotExists": true });
      })
    )
  };
} 

@Injectable({
  providedIn: 'root'
})
export class AdminHelperService {

  constructor(private _modalService: BsModalService) { }

  public getUserTableColumns(activeTab:any) : (ColDef | ColGroupDef)[] {
    return [
      { headerName: 'GID', field: 'gid',pinned:'left',maxWidth:100,},
      { headerName: 'User Name', field: 'user_name',pinned:'left'},
      { headerName: 'Email ID', field: 'user_email',pinned:'left'},
      { headerName: 'Company Code', field: 'company_code',filter: true },
      { headerName: 'Plant Code', field: 'plant_code', },
      { headerName: 'Location', field: 'location',maxWidth:100, },
      { headerName: 'Currency', field: 'currency',maxWidth:100 },
      { headerName: 'Threshold from', field: 'netprice_start',maxWidth:150, },
      { headerName: 'Threshold to', field: 'netprice_end',maxWidth:150, },
      { headerName: 'Division', field: 'division' },
      { headerName: 'Commodity', field: 'commodity' },
      { headerName: 'IM/DM', field: 'direct_indirect' },
      { headerName: 'Role', field: 'role',pinned:'left',maxWidth:100, },
      {
        headerName: 'Actions', pinned: 'right', resizable: true,maxWidth:100,
        cellRenderer: 'AgGridActionsRendererComponent',
        /* cellRenderer:() => {
          return '<span><i class="fa fa-ellipsis-v" style="cursor: pointer;" title="Actions"></i></span>';
        }, */
        cellRendererParams: (user:IUser) => {
          if(activeTab.tabType === AdminDashboardEnum.USER && user.role !== AdminDashboardEnum.SUPPLIER){
            return [
              { name: "View Details", icon: "fa-eye" },
              { name: "Copy Role", icon: "fa-copy" },
              { name: "GL Account Mapping", icon: "fa-edit" },
              { name: "Cost Center Mapping", icon: "fa-edit" },
              { name: "Deactivate", icon: "fa-ban" }
          ]

          }else if(activeTab.tabType === AdminDashboardEnum.USER && user.role === AdminDashboardEnum.SUPPLIER){
            return [
              { name: "View Details", icon: "fa-eye" },
              { name: "Copy Role", icon: "fa-copy" },
              { name: "GL Account Mapping", icon: "fa-edit" },
              { name: "Cost Center Mapping", icon: "fa-edit" },
              { name: "Edit Supplier EFA", icon: "fa-edit" },
              { name: "Deactivate", icon: "fa-ban" }
          ]
          } else{
            return [
              { name: "View Details", icon: "fa-eye" },
              { name: "Activate", icon: "fa-check-square-o"}]
          }
        },
        cellEditor: 'AgGridActionsWrapperComponent',
        cellEditorPopup: true,
        singleClickEdit: true,
        editable: true,
        
        // cellRenderer: "btnCellRenderer",
        // cellRendererParams: {
        //   clicked: (val : IUser) => this.addNewUser(val, "UPDATE")
        // },
        // minWidth: 350
      }
    ];
  }

  public openUserDetailsModal(user: IUser | null, userActionType : "CREATE" | "UPDATE"|"COPY" = "CREATE", masterData : Record<AdminMasterEnum | string, string[]>) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: userActionType === "CREATE" ? "Create new User" : "Update User",
        user,
        masterData,
        userActionType
      },
      backdrop: 'static',
      class : 'modal-lg'
    };
    const bsModalRef : BsModalRef = this._modalService.show(UserDetailsComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openMasterPopup(masterTab: IAdminMasterTab) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: `${masterTab.title}`,
        masterTab
      },
      backdrop: 'static',
      class : 'modal-md'
    };
    const bsModalRef : BsModalRef = this._modalService.show(MasterPopupComponent, initialState);
    return bsModalRef.content.onClose
  }


  public openMappingPopup(title:any, user:IUser ) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: title,
        user:user
      },
      backdrop: 'static',
      class : 'modal-md'
    };
    const bsModalRef : BsModalRef = this._modalService.show(MappingPopupComponent, initialState);
    return bsModalRef.content.onClose
  }

  public openSupplierEFA(title:any, user:IUser ) {
    const initialState: ModalOptions<any> = {
      initialState: {
        title: title,
        user:user
      },
      backdrop: 'static',
      class : 'modal-md'
    };
    const bsModalRef : BsModalRef = this._modalService.show(SupplierPopupComponent, initialState);
    return bsModalRef.content.onClose
  }
}
